import React from 'react';
import { Segment, Divider } from 'semantic-ui-react';
import { PeriodicCyclingSetting } from '../Components/PeriodicCycling';
import StatusView from '../Components/Debug/StatusView';
import AdcancedRangeConfig from '../Components/ConfigRange';
//import Ekkolodd from '../Components/Debug/Ekkolodd';
//import Rotation from '../Components/Debug/AhrsRotation';
//import TempShutdownSetting from '../Components/Debug/DebugTempShutdown';

function Debug() {
    return (
        <Segment attached>
            <Divider horizontal>Debug</Divider>

            <AdcancedRangeConfig />

            <PeriodicCyclingSetting />

            <Divider horizontal>Status</Divider>
            <StatusView detailed={true} collapsing={true} />

            {/* <Divider horizontal>[Dev] Temperature shutdown</Divider>
            <TempShutdownSetting /> */}

            {/* <Divider horizontal>[Dev] Rotation view</Divider>
            <Rotation /> */}

            {/* <Divider horizontal>[Dev] Echo sounder view</Divider>
            <Ekkolodd /> */}
        </Segment>
    );
}

export default Debug;
